import {Component, Input, OnInit} from '@angular/core';
import {SpezialWetter} from '../../../../../../../model/vorhersagen/rbb-document';

@Component({
  selector: 'app-spezialwetter-bericht',
  templateUrl: './spezialwetter-bericht.component.html',
  styleUrls: ['./spezialwetter-bericht.component.css']
})
export class SpezialwetterBerichtComponent {

  @Input()
  spezialwetter: SpezialWetter;

}
